/* Mia layout helpers — homepage sticky call-to-action. No dependencies, no network. */
(function () {
  'use strict';

  function initStickyCta(root) {
    (root || document).querySelectorAll('[data-mia-stickycta]:not([data-ready])').forEach(function (bar) {
      bar.setAttribute('data-ready', '');
      var target = document.querySelector(bar.getAttribute('data-target') || '.mia-hero');
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var pastIt = !e.isIntersecting && e.boundingClientRect.bottom < 0;
        bar.classList.toggle('is-visible', pastIt);
        bar.setAttribute('aria-hidden', pastIt ? 'false' : 'true');
        if (pastIt) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
      }, { threshold: 0 }).observe(target);
    });
  }

  function init() { initStickyCta(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { initStickyCta(e.target); });
})();
